import { InputError } from '../interfaces';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

export const PasswordErrorRequired: InputError = {
  errorCode: 'required',
  errorMessage: _('validation.password.required'),
};
export const PasswordNotMatch: InputError = {
  errorCode: 'matchOther',
  errorMessage: _('validation.password.not_matching'),
};
export const PasswordDontMatchOther: InputError = {
  errorCode: 'dontMatchOtherValidator',
  errorMessage: _('validation.password.do_not_match'),
};
